import React, { ReactNode, useEffect, useRef } from "react";
import DropdownArrow from "@/public/icons/dropdownArrow.svg";
import PinHollow from "@/public/icons/pin-orange-hollow.svg";

type Props = {
  title: string;
  LeftIcon: ReactNode;
  titleClassName?: string;
  containerClassName?: string;
  data: { key: string | null; heading: string; subHeading: string; pillText?: string }[];
  selectedData: string | null | undefined;
  setSelectedData: (key: string | null) => void;
  rowClassName?: string;
  rowIcon?: React.ReactNode;
  selectedRowIcon?: React.ReactNode;
  selectedRowClassName?: string;
};

export const Dropdown = ({ title, LeftIcon, data, selectedData, setSelectedData }: Props) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div
      className={`w-full flex flex-col border  border-landing-orange cursor-pointer ${
        isOpen ? "rounded-[30px] rounded-b-[0px]" : "rounded-full z-40"
      }`}
      ref={dropdownRef}
    >
      <div
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        className={`h-[66px] w-full group justify-between  flex items-center gap-2 xs:gap-4 px-4 py-[21px] text-sm font-medium  `}
      >
        <div className="flex items-center gap-2 xs:gap-4">
          {LeftIcon}
          <span className={`text-center font-medium transition-colors text-lg  text-landing-blue`}>
            {selectedData ? data.find((item) => item.key === selectedData)?.heading : title}
          </span>
        </div>

        <div className={`transition-transform ${isOpen ? "rotate-180" : "rotate-0"}`}>
          <DropdownArrow />
        </div>
      </div>
      <div>
        <div
          className={` absolute  w-full border-landing-orange border-t-0 ${
            isOpen ? " h-[340px] border  left-0 top-full  bg-white rounded-b-[30px]  z-50" : "h-0"
          } overflow-y-auto transition-all duration-0  max-w-[470px] no-scrollbar `}
        >
          <div className="py-2">
            {data.map((item) => (
              <div
                key={item.key}
                className="px-4 py-2 gap-4 items-center justify-between flex hover:bg-[#F392371F] cursor-pointer"
                onClick={() => {
                  setIsOpen(false);
                  setSelectedData(item.key);
                }}
              >
                <div className="flex items-center gap-4">
                  <PinHollow />
                  <div>
                    <div className="font-medium text-lg text-left text-landing-blue">
                      {item.heading}
                    </div>
                    <div className="text-sm text-left">{item.subHeading}</div>
                  </div>
                </div>
                {item.pillText && (
                  <span className="bg-landing-magenta text-white text-sm font-medium uppercase px-4 py-1 rounded whitespace-nowrap">
                    {item.pillText}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
